import { ProtectedByPermissionRoute } from '@/components/ProtectedByPermissionRoute'
import { AuthProvider } from '@/contexts/AuthContext'
import ConfigurarSenha from '@/pages/auth/ConfigurarSenha'
import Login from '@/pages/login/Login'
import { QueryProvider } from '@/providers/QueryProvider'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import Agendamentos from './pages/agendamentos/Agendamentos'
import ValidarDocumentoPage from './pages/assinaturas/ValidarDocumentoPage'
import Atendimentos from './pages/atendimentos/Atendimentos'
import AtendimentoForm from './pages/atendimentos/Atendimentos-edit'
import Configuracoes from './pages/config/Configuracoes'
import GoogleMeetCallback from './pages/config/GoogleMeetCallback'
import ControleAcessoPage from './pages/controle_acesso/controle_acesso'
import ConveniosPage from './pages/convenios/convenios'
import Dashboard from './pages/dashboard/Dashboard'
import EspecialidadesPage from './pages/especialidades/especialidades'
import ExamesPage from './pages/exames/exames'
import DashboardPaciente from './pages/paciente/DashboardPaciente'
import Pacientes from './pages/pacientes/Pacientes'
import PerfilAcessoPage from './pages/perfil_acesso/perfil-acesso'
import TipoAtendimentoPage from './pages/tipo_atendimento/tipo_atendimento'
import Usuarios from './pages/usuarios/Usuarios'

export default function App() {
  const validarDocumentoElement = (
    <ProtectedByPermissionRoute>
      <ValidarDocumentoPage />
    </ProtectedByPermissionRoute>
  )

  return (
    <QueryProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/configurar-senha" element={<ConfigurarSenha />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedByPermissionRoute>
                  <Dashboard />
                </ProtectedByPermissionRoute>
              }
            />
            <Route
              path="/usuarios"
              element={
                <ProtectedByPermissionRoute>
                  <Usuarios />
                </ProtectedByPermissionRoute>
              }
            />
            <Route
              path="/pacientes"
              element={
                <ProtectedByPermissionRoute>
                  <Pacientes />
                </ProtectedByPermissionRoute>
              }
            />
            <Route
              path="/atendimentos"
              element={
                <ProtectedByPermissionRoute>
                  <Atendimentos />
                </ProtectedByPermissionRoute>
              }
            />
            <Route
              path="/atendimento/:patientId"
              element={
                <ProtectedByPermissionRoute>
                  <AtendimentoForm />
                </ProtectedByPermissionRoute>
              }
            />
            <Route
              path="/paciente/dashboard"
              element={
                <ProtectedByPermissionRoute>
                  <DashboardPaciente />
                </ProtectedByPermissionRoute>
              }
            />
            {/* <Route
              path="/paciente/meus-documentos"
              element={
                <ProtectedByPermissionRoute>
                  <ExamsDocumentsPaciente
                    defaultTab="documentos_paciente"
                    title="Meus Documentos"
                    subtitle="Documentos enviados por você"
                  />
                </ProtectedByPermissionRoute>
              }
            /> */}
            {/* <Route
              path="/paciente/exames"
              element={
                <ProtectedByPermissionRoute>
                  <ExamsDocumentsPaciente defaultTab="exames" />
                </ProtectedByPermissionRoute>
              }
            /> */}
            {/* <Route
              path="/paciente/documentos"
              element={
                <ProtectedByPermissionRoute>
                  <ExamsDocumentsPaciente
                    defaultTab="documentos_medico"
                    title="Documentos"
                    subtitle="Documentos do médico e seus envios"
                  />
                </ProtectedByPermissionRoute>
              }
            /> */}
            {/* <Route
              path="/paciente/meus-dados"
              element={
                <ProtectedByPermissionRoute>
                  <MeusDados />
                </ProtectedByPermissionRoute>
              }
            /> */}
            <Route
              path="/especialidades"
              element={
                <ProtectedByPermissionRoute>
                  <EspecialidadesPage />
                </ProtectedByPermissionRoute>
              }
            />
            <Route
              path="/tipo-atendimento"
              element={
                <ProtectedByPermissionRoute>
                  <TipoAtendimentoPage />
                </ProtectedByPermissionRoute>
              }
            />
            <Route
              path="/exames"
              element={
                <ProtectedByPermissionRoute>
                  <ExamesPage />
                </ProtectedByPermissionRoute>
              }
            />
            <Route
              path="/convenios"
              element={
                <ProtectedByPermissionRoute>
                  <ConveniosPage />
                </ProtectedByPermissionRoute>
              }
            />
            <Route
              path="/configuracoes"
              element={
                <ProtectedByPermissionRoute>
                  <Configuracoes />
                </ProtectedByPermissionRoute>
              }
            />
            <Route
              path="/controle_acesso"
              element={
                <ProtectedByPermissionRoute>
                  <ControleAcessoPage />
                </ProtectedByPermissionRoute>
              }
            />
            <Route
              path="/perfil_acesso"
              element={
                <ProtectedByPermissionRoute>
                  <PerfilAcessoPage />
                </ProtectedByPermissionRoute>
              }
            />
            <Route
              path="/agendamentos"
              element={
                <ProtectedByPermissionRoute>
                  <Agendamentos />
                </ProtectedByPermissionRoute>
              }
            />
            <Route
              path="/assinaturas/validar-documento"
              element={validarDocumentoElement}
            />
            <Route
              path="/assinaturas/validar-documentos"
              element={validarDocumentoElement}
            />
            <Route
              path="/validar-documento"
              element={validarDocumentoElement}
            />
            <Route
              path="/validar-documentos"
              element={validarDocumentoElement}
            />
            <Route
              path="/google-meet/callback"
              element={<GoogleMeetCallback />}
            />
            <Route path="/" element={<Navigate to="/usuarios" replace />} />
            <Route path="*" element={<Navigate to="/usuarios" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryProvider>
  )
}
